import { array } from '@ember/helper';
import { t } from 'ember-intl';
import { and, or } from 'ember-truth-helpers';
import can from 'ember-can/helpers/can';
import { LayoutSidebarSubnav } from 'core/components';

<template>
  <LayoutSidebarSubnav data-test-organizations-sidebar-container as |Subnav|>
    <Subnav.BackLink
      @text={{t "nav.back-to-cloud-dashboard"}}
      @route="cloud.orgs.detail"
      @models={{array @controller.model.organization.id}}
      @current-when={{false}}
    />
    <Subnav.Title>
      {{t "nav.organization.settings.header"}}
    </Subnav.Title>
    <Subnav.Link
      @text={{t "components.page.organizations.settings.tabs.organization"}}
      @route="cloud.orgs.detail.settings.index"
      @model={{@controller.model.organization.id}}
    />
    {{#if (or (can "CRUD sso") (can "CRUD auth-connection"))}}
      <Subnav.Link
        @text={{t "components.page.organizations.settings.tabs.sso"}}
        @route="cloud.orgs.detail.settings.sso"
        @model={{@controller.model.organization.id}}
      />
    {{/if}}
    {{#if (and (can "get scim") (can "list scim-token"))}}
      <Subnav.Link
        @text={{t "components.page.organizations.detail.scim.header.title"}}
        @route="cloud.orgs.detail.settings.scim"
        @badge={{t
          "components.page.organizations.detail.scim.header.beta-badge"
        }}
        data-test-scim-subnav-link
      />
    {{/if}}
  </LayoutSidebarSubnav>

  {{outlet}}
</template>
